import React, { Component } from 'react';
import { compose, lifecycle } from "recompose";
import { withRouter } from 'react-router-dom';
import TaskElement from './TaskElement.js';
import './Tasks.css';
import _ from 'lodash';

import fire from './fire';

class Tasks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projects: [],
    };
  }

  componentWillMount() {
    /* Create reference to messages in Firebase Database */
    let projectsRef = fire.database().ref('projects').orderByKey().limitToLast(20);
    projectsRef.on('child_added', snapshot => {
      /* Update React state when message is added at Firebase Database */
      let project = snapshot.val();
      project.id = snapshot.key;
      this.setState((prevState) => { 
        return {projects: [project].concat(prevState.projects)};
      });
    })
  }

  render() {
    const tasks = []

    this.state.projects.map(project => {
      if (project.status > 0 && project.solutions) {
        project.solutions.map((solution, solutionId) => {
          if (solution.tasks) {
            solution.tasks.map((task, taskId) => {
              tasks.push(_.assign({}, task, {id: taskId, solutionId, projectId: project.id, projectName: project.name, globalGoals: project.globalGoals}));
            })
          }
        })
      } else {
        tasks.push(_.assign({},project, {isProject: true}))
      }
    })

    return (
      <div className="tasks">
        {
          tasks.map((task, index) => (
            <TaskElement
              onClick={() => {
                if (task['isProject']){
                  this.props.history.push(`/projects/${task.id}`);
                } else {
                  this.props.history.push(`/projects/${task.projectId}/solutions/${task.solutionId}/tasks/${task.id}`);
                }
              }}
              data={task}
              key={index}
            />
          ))
        }
      </div>
    );
  }
}

export default withRouter(Tasks);



// WEBPACK FOOTER //
// ./src/Tasks.js